import { NfcVariantIcon } from './NfcVariantIcon';

/**
 * author: Google
 * id 4DFF5414-0EA3-4255-BC50-B40B0E3ADB15
 * name nfc-variant
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/nfc-variant.svg
 * tags
 * - Home Automation 
 */
export const NearFieldCommunicationVariantIcon = NfcVariantIcon;
export default NearFieldCommunicationVariantIcon